import { Button } from '@mui/material'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import logo from '../../assets/Images/TMDSAS_Logo_2020.png'
import './authNavbar.css'
import { baseURLRoute } from '../../constants/routeConstants'

const AuthNavbar = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const checkIfNotLogin = (path) => {
        const locationRegex = new RegExp(baseURLRoute + '/[^/]+', 'i')
        return locationRegex.test(path)
    }

    return (
        <nav className="navbar auth-navbar">
            <a
                className="auth-nav-bar-icon-container"
                onClick={() => window.open('https://tmdsas.com', '_blank')}>
                <img src={logo} height={75} />
            </a>
            {checkIfNotLogin(location.pathname) ? (
                <div className="auth-navbar-button-container">
                    <Button
                        onClick={() => {
                            sessionStorage.clear()
                            navigate(baseURLRoute)
                        }}
                        className="auth-navbar-button"
                        variant="contained"
                        color="primary"
                        sx={{
                            fontSize: '14px',
                            marginRight: '1rem',
                            backgroundColor: '#00B4AC',
                            ':hover': {
                                backgroundColor: '#10918C',
                            },
                        }}>
                        Login
                    </Button>
                </div>
            ) : null}
        </nav>
    )
}
export default AuthNavbar
